import { API_URL } from '../configAndUrls.js'
import { apiRequest, getAuthHeaders } from '../http.js'

export function createAssignmentsApi() {
  const assignmentsApi = {
createSlots: async (assignmentId, slots) => {
      const body = Array.isArray(slots) ? { slots } : slots
      const data = await apiRequest(`/assignments/${assignmentId}/slots`, {
        method: 'POST',
        body: JSON.stringify(body),
      })
      return data.slots || []
    },

    getPresignedContract: async (assignmentId, filename, contentType) => {
      const params = new URLSearchParams({ filename })
      if (contentType) params.set('contentType', contentType)
      const response = await fetch(`${API_URL}/assignments/${assignmentId}/presigned-contract?${params}`, {
        headers: getAuthHeaders(),
      })
      const data = await response.json().catch(() => ({}))
      if (response.status === 503 && data.error === 'S3_NOT_CONFIGURED') return null
      if (!response.ok) throw new Error(data.error || data.message || 'Failed to get upload URL')
      return data
    },

    confirmContractFromS3: async (assignmentId, publicUrl) => {
      const data = await apiRequest(`/assignments/${assignmentId}/contract-from-s3`, {
        method: 'POST',
        body: JSON.stringify({ public_url: publicUrl }),
      })
      return data.assignment
    },

    uploadContract: async (assignmentId, file) => {
      const presigned = await assignmentsApi.getPresignedContract(assignmentId, file.name, file.type)
      if (presigned) {
        const putRes = await fetch(presigned.uploadUrl, {
          method: 'PUT',
          body: file,
          headers: { 'Content-Type': file.type || 'application/octet-stream' },
        })
        if (!putRes.ok) {
          const text = await putRes.text()
          throw new Error(`S3 upload failed (${putRes.status}). ${text.slice(0, 80)}`)
        }
        return assignmentsApi.confirmContractFromS3(assignmentId, presigned.publicUrl)
      }

      const formData = new FormData()
      formData.append('file', file)
      const response = await fetch(`${API_URL}/assignments/${assignmentId}/contract`, {
        method: 'POST',
        headers: getAuthHeaders(),
        body: formData,
      })
      if (!response.ok) {
        const err = await response.json()
        throw new Error(err.error || 'Upload failed')
      }
      const data = await response.json()
      return data.assignment
    },
  }
  return assignmentsApi
}
